<template>
    <div>
        <div v-if="activeBulkPayment && activeBulkPayment.bank_logs" class="pa-5">
            <div v-for="item in activeBulkPayment.bank_logs" :key="item.id">
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Log ID" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.id ? item.id : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Payment ID" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.payment_id ? item.payment_id : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Created at" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.created_at ? tz(item.created_at) : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Updated at" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.updated_at ? tz(item.updated_at) : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Bank ID" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.bank_id ? item.bank_id : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Bank name" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.bank_name ? item.bank_name : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Bank swift" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.bank_swift ? item.bank_swift : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Request url" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.request_url ? item.request_url : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Request headers" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        <vue-json-pretty
                            v-if="isJSON(item.request_headers)"
                            :data="JSON.parse(item.request_headers)"
                            :deep="0"
                            collapsedOnClickBrackets
                        />
                        <div v-else>
                            {{ item.request_headers && item.request_headers.length > 0 ? item.request_headers : "-" }}
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Request body" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        <vue-json-pretty
                            v-if="isJSON(item.request_body)"
                            :data="JSON.parse(item.request_body)"
                            :deep="0"
                            collapsedOnClickBrackets
                        />
                        <div v-else>
                            {{ item.request_body && item.request_body.length > 0 ? item.request_body : "-" }}
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Request parameters" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        <vue-json-pretty
                            v-if="isJSON(item.request_params)"
                            :data="JSON.parse(item.request_params)"
                            :deep="0"
                            collapsedOnClickBrackets
                        />
                        <div v-else>
                            {{ item.request_params && item.request_params.length > 0 ? item.request_params : "-" }}
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Response headers" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        <vue-json-pretty
                            v-if="isJSON(item.response_headers)"
                            :data="JSON.parse(item.response_headers)"
                            :deep="0"
                            collapsedOnClickBrackets
                        />
                        <div v-else>
                            {{
                                item.response_headers && item.response_headers.length > 0 ? item.response_headers : "-"
                            }}
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Response body" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        <vue-json-pretty
                            v-if="isJSON(item.response_body)"
                            :data="JSON.parse(item.response_body)"
                            :deep="0"
                            collapsedOnClickBrackets
                        />
                        <div v-else>
                            {{ item.response_body && item.response_body.length > 0 ? item.response_body : "-" }}
                        </div>
                    </v-col>
                </v-row>
                <v-divider class="mb-6 mt-6" />
            </div>
        </div>
        <div v-else class="pa-5">{{ "No data" | t }}</div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
    name: "bank-logs-tab",
    components: {
        VueJsonPretty
    },
    computed: {
        ...mapState('bulkPaymentHistory', ["activeBulkPayment"])
    },
    methods: {
        isJSON(value) {
            try {
                JSON.parse(value);
                return true;
            } catch (e) {
                return false;
            }
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>
